<template>
    <div class="col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0 text-center" v-if="!is_data_ready">
        <span class="loader"></span>
    </div>

    <div class="col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0 text-center" v-else-if="!player">
        <p>No detail data found.</p>
    </div>

    <div class="col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0" v-else>

        <div class="player-details">
            <div class="avtar" v-if="player.gender == 'male' || player.gender == 'Male'  || player.gender == 'M' || player.gender == 'MALE'">
                <img :src="('https://img.sixlogics.com/avatars/cricket/players/300x300/'+player.id+'.png').resizeImage(90)"   @error="$event.target.src='/public/images/User_Male.jpg'" alt="">
            </div>
            <div class="avtar" v-else-if=" player.gender == 'female' || player.gender == 'F' || player.gender == 'FEMALE'| player.gender == 'Female'">
                <img :src="('https://img.sixlogics.com/avatars/cricket/players/300x300/'+player.id+'.png').resizeImage(90)"   @error="$event.target.src='/public/images/User_Female.jpg'" alt="">
            </div>
            <div class="avtar" v-else>
                <img :src="('https://img.sixlogics.com/avatars/cricket/players/300x300/'+player.id+'.png').resizeImage(90)"   @error="$event.target.src='/public/images/User_Male.jpg'" alt="">
            </div>
            <div class="descrip">
                <div class="descrip-top">
                    <h1 class="name">{{player.name}} {{  geth1  }}</h1>
                </div>
                <ul class="descrip-list">
                    <li>
                        <span class="title">Gender</span>
                        <span class="sub-title"><span class="text">{{player.gender ? player.gender = player.gender.charAt(0).toUpperCase() + player.gender.slice(1) : ''}}</span></span>
                    </li>
                    <li>
                        <span class="title">Born</span>
                        <span class="sub-title">
                            <span class="icon-flag"><img :src="('https://api.planetcricket.com/storage/country_flags/'+ player.country_id +'.png').resizeImage(25)" alt=""></span>
                            <span class="text">{{player.country  && player.country != " " ? player.country.name : 'Not Available' }}</span>
                        </span>
                    </li>
                    <li>
                        <span class="title">Age</span>
                        <span class="sub-title"><span class="text">{{player.age? player.age+' Years' :'-'}} </span></span>
                    </li>
                    <li>
                        <span class="title">Batting style</span>
                        <span class="sub-title"><span class="text">{{player.batting_style ? player.batting_style = player.batting_style.charAt(0).toUpperCase() + player.batting_style.slice(1) : '' }}</span></span>
                    </li>
                    <li>
                        <span class="title">Bowling style</span>
                        <span class="sub-title"><span class="text">{{player.bowling_style ? player.bowling_style = player.bowling_style.charAt(0).toUpperCase() + player.bowling_style.slice(1) : ''}}</span></span>
                    </li>
                    <li>
                        <span class="title">Playing Role</span>
                        <span class="sub-title"><span class="text">{{player.role ? player.role = player.role.charAt(0).toUpperCase() + player.role.slice(1) : ''}}</span></span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="nav-tabs-wrap">
            <ul class="nav nav-tabs" role="tablist">

                <li role="tab"><router-link :to="{name: 'playerDetail.info'}" :class="{'active' : $route.name=='playerDetail.info'}">Info</router-link></li>
                <li role="tab"><router-link :to="{name: 'playerDetail.Battingbowlingstats'}" :class="{'active' : $route.name=='playerDetail.Battingbowlingstats'}">Stats</router-link></li>
                <li role="tab"><router-link :to="{name: 'playerDetail.Social'}" :class="{'active' : $route.name=='playerDetail.Social'}">Social</router-link></li>
                <li role="tab"><router-link :to="{name: 'playerDetail.match'}" :class="{'active' : $route.name=='playerDetail.match'}">Matches</router-link></li>

            </ul>
        </div>
        <div class="tab-content">
            <router-view />
        </div>

    </div>

</template>

<script>
    import Vue from 'vue'
    import moment from 'moment'
    export default {
        name: 'playerDetail',
        data() {
            return {
                player: [],
                // age: ''
            }
        },
        jsonld() {

            if (isServer)
                return {
                    "@context": "http://schema.org",
                    "@graph": []
                }

            if (!this.is_data_ready)
                return

                return {
                    "@context": "http://schema.org",
                    "@type": "Person",
                    "name": this.player.name,
                    "alternateName": this.player.nick,
                    "address": this.player.birth_place,
                    "height": this.player.height,
                    "weight": this.player.weight,
                    "gender": this.player.gender,
                    "birthDate": moment(this.player.dob).format('YYYY-MM-DD HH:MM'),
                    "birthPlace": this.player.birth_place,
                    "description": "role "+this.player.role+ " "+ this.player.batting_style+" " + this.player.bowling_style+ " " + this.player.education,
                    "image": "https://planetcricket.com/public/images/logo1280x720.png"
                };

        },

        metaInfo() {

            if (!this.player)
                return

            let title = this.player.full_name != undefined ? this.player.full_name + " Info - PlanetCricket.com" : 'https://planetcricket.com'+this.$route.path;
            let description = this.player.full_name != undefined ? this.player.full_name + " Info - PlanetCricket.com" : 'https://planetcricket.com'+this.$route.path;
            return {
                title: title,
                meta: this.$getMetaTags(title, description),
                link:[
                        {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
            }

        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.main();
            }
        },
         computed: {

            geth1() {
                if(this.$route.path.split('/')[3] == "Batting-Bowling-Stats")
                {
                    return (this.$route.path.split('/')[3]).split('-').join(' ')
                }
                else if(this.$route.path.split('/')[3] == "match")
                {
                   return 'Stats';
                }

                 return   this.$route.path.split('/')[3][0].toUpperCase() + this.$route.path.split('/')[3].slice(1).toLowerCase()
            },
        },
        mounted() {
           this.$root.$on('playerDetail', () => {
                this.main();
           });
          this.main();
        },

        methods: {
            main() {

                return this.$axios
                        .get(this.$PLAYER_DETAIL_API.replace(':player', this.$route.params.player))
                        .then(response => {
                            this.is_data_ready = true

                            this.player = response.data.result;
                            if(this.player.dob != undefined){
                                this.player.dob = moment(String(this.player.dob)).format('YYYY-MM-DD');
                            }
                            /* if(this.player.age != undefined){
                                this.player.age = this.ageCalculate(this.player.dob);
                            } */
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            },
            /* ageCalculate(DOB) {
                var date = new Date().toISOString().slice(0, 10);
                var datee = moment(date).format('YYYY-MM-DD');
                if (DOB < datee)
                {
                    return  this.age = Vue.filter('age')(DOB);
                } else
                {
                    return this.age = '';
                }
            } */
        }
    }
</script>
